import { FC } from 'react'
import { SVGs } from '../../../../assets'
import { BitazzaText } from '../../../../components'
import { Badges } from '../../../LeaderBoard/components'
import Style from './ChallengerBox.module.scss'
import { formatProfileName } from '../../../../util/formatProfileName'

interface Props {
    tier: string
    highlighted: boolean
    profileName?: string
    score: string
    rank: string
    performance?: performanceRequest
    seasonSummary?: boolean
    seasonEnd?: boolean
}

export const ChallengerBox: FC<Props> = ({
    tier,
    highlighted,
    profileName,
    score,
    rank,
    performance,
    seasonSummary,
    seasonEnd,
}) => {
    let userPnl: string | undefined = score
    if (!userPnl && performance) {
        userPnl = performance.data?.pnl_online?.toString()
    }
    const getColor = (rank: string) => {
        switch (rank) {
            case 'GRANDMASTER':
                return '#FFD347'

            case 'MASTER':
                return '#BC68FF'
            case 'DIAMOND':
                return '#5A8AE8'
            case 'GOLD':
                return '#BDA446'
            case 'SILVER':
                return '#84A1C8'
            case 'BRONZE':
                return '#9F7C67'
            default:
                return '#8F909E'
        }
    }

    const getBadgeColor = (rank: string) => {
        switch (rank) {
            case 'GRANDMASTER':
                return '#E7A423'

            case 'MASTER':
                return '#8E14ED'
            case 'DIAMOND':
                return '#467BE4'
            case 'GOLD':
                return '#A68E39'
            case 'SILVER':
                return '#6285B0'
            case 'BRONZE':
                return '#745543'
            default:
                return '#848591'
        }
    }

    const getText = (rank: string) => {
        switch (rank) {
            case 'GRANDMASTER':
            case 'GM':
                return (
                    <div className={Style.textContainer}>
                        <BitazzaText
                            content={'GRAND'}
                            color={getColor(tier?.toUpperCase())}
                            lineHeight={12}
                            bold
                            letterSpacing={2}
                        />
                        <BitazzaText
                            lineHeight={12}
                            content={'MASTER'}
                            color={getColor(tier?.toUpperCase())}
                            bold
                            letterSpacing={2}
                        />
                    </div>
                )
            default:
                return (
                    <BitazzaText
                        letterSpacing={2}
                        lineHeight={2}
                        content={tier?.toUpperCase()}
                        color={getColor(tier?.toUpperCase())}
                        bold
                        style={{
                            paddingTop:
                                highlighted && seasonEnd
                                    ? '16px'
                                    : seasonEnd
                                    ? '12px'
                                    : '0px',
                        }}
                    />
                )
        }
    }
    return (
        <div
            className={Style.container}
            style={{ width: seasonSummary ? '120px' : 'initial' }}
        >
            <div
                className={Style.challengerAvatar}
                style={{
                    left: seasonSummary ? '-12px' : '10px',
                    position: seasonSummary ? 'absolute' : 'initial',
                }}
            >
                <Badges
                    type={tier}
                    big
                    highlighted={highlighted}
                    seasonSummery={seasonSummary}
                />
                <div
                    className={Style.challengerRank}
                    style={{
                        left: seasonSummary ? '34%' : '30%',
                        bottom: highlighted ? '4px' : '2px',
                        backgroundColor: getBadgeColor(tier?.toUpperCase()),
                    }}
                >
                    <img src={SVGs.trophyIcon} alt="trophy" width={14} />
                    <BitazzaText
                        content={rank ? rank : 'N/A'}
                        format="t16"
                        color="#FFFFFF"
                        bold
                    />
                </div>
            </div>
            <div
                className={Style.challengerContent}
                style={{
                    height: highlighted ? '210px' : '180px',
                    top: seasonSummary
                        ? '110px'
                        : highlighted
                        ? '100px'
                        : '80px',
                    width: seasonSummary ? '120px' : '100%',
                }}
            >
                <div
                    style={{
                        top: highlighted ? '24px' : '14px',
                        position: 'relative',
                    }}
                >
                    {getText(tier)}
                    <div className={Style.challengerName}>
                        <BitazzaText
                            format="t20"
                            bold
                            content={formatProfileName(profileName)}
                            color={'#FFF'}
                            textAlign="center"
                            style={{
                                whiteSpace: profileName?.includes('Challenger')
                                    ? 'pre-line'
                                    : 'nowrap',
                            }}
                        />
                        {userPnl && !seasonSummary ? (
                            <>
                                <BitazzaText
                                    format="t12"
                                    bold
                                    content={'PNL'}
                                    color={'rgba(255,255,255,0.5)'}
                                    textAlign="center"
                                    lineHeight={6}
                                />
                                <BitazzaText
                                    format="t20"
                                    bold
                                    style={{ margin: 0, padding: 0 }}
                                    content={userPnl + '%'}
                                    color={'#F1D87E'}
                                    textAlign="center"
                                    lineHeight={20}
                                />
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

ChallengerBox.defaultProps = {
    tier: '',
}
